import React from 'react';
import Money from "../../../../../../../components/Common/Money";
import {useTranslation} from "react-i18next";
import {ReactComponent as MenuItemIco} from "../../../../../../../../images/icons/menus/menu-item.svg";
import {ReactComponent as MenuItemDarkIco} from "../../../../../../../../images/icons/menus/menu-item-dark.svg";
import ProductModifierGroupAdvancedSubOptions from "../Advanced/ProductModifierGroupAdvancedSubOptions";
import AppConfig from "../../../../../../../services/AppConfig";
import StoreUtils from "../../../../../../../services/Store/StoreUtils";
import {ConfigApi} from "../../../../../../../services/Api/types";
import MenuHelper from "../../../../../../../services/Menu/services/Menu/MenuHelper";

interface Props {
    option: Record<string, any>;
    adjustOption: (optionState: Record<string, any>, stateIndex: number) => void;
    isProductAvailable: boolean;
    config: ConfigApi | undefined;
    menuId?: number;
}

const ProductModifierGroupAdvancedOptionIncluded = ({
                                                        option,
                                                        adjustOption,
                                                        isProductAvailable,
                                                        config,
                                                        menuId
                                                    }: Props) => {
    const {t} = useTranslation();
    const isReadonly = StoreUtils.isOrderingReadonly(config);
    const disabled = isReadonly ? false : option.disabled;

    const getTotalPrice = () => {
        return option.states.reduce((acc: number, state: Record<string, any>) => acc + state.total_price, 0);
    }

    return (
        <div
            className={`product-item-option product-modifier-group-option product-modifier-group-option-advanced ${disabled ? "disabled" : ""} ${isReadonly ? "not-clickable" : ""}`}>
            <div className="d-flex">
                <div className="product-image">
                    {option.image_small ? (
                        <img alt={t("common.word.product_image")}
                             src={option.image_small}/>
                    ) : (
                        AppConfig.isDarkMode() ? <MenuItemDarkIco/> : <MenuItemIco/>
                    )}
                </div>
                <div className="d-flex flex-column w-100">
                    {disabled &&
                        <small
                            className="text-warning fw-normal">{t("modules.menu.product_not_available.field")}</small>}
                    <h1 className="h6">
                        {MenuHelper.capitalizeFirstLetterOfName(option.name)}
                    </h1>
                    {option.description && (
                        <p className="fw-normal">{option.description}</p>
                    )}
                    <div className="d-flex justify-content-between align-items-center gap-3 w-100">
                        <p className="price">
                            <Money
                                value={getTotalPrice()}
                                currency='PLN'/>
                        </p>
                    </div>
                </div>
            </div>
            {
                option.modifier_groups.length > 0 && option.states.length > 0 && (
                    <div className="product-modifier-group-option-advanced-sub-options">
                        <ProductModifierGroupAdvancedSubOptions
                            modifierGroupOption={option}
                            options={option.modifier_groups || []}
                            handleAdjustOption={adjustOption}
                            handleRemoveOption={undefined}
                            isProductAvailable={isProductAvailable}
                            preventShowModalOnCheckingConfiguration
                            menuId={menuId}
                        />
                    </div>
                )
            }
        </div>
    )
}
export default ProductModifierGroupAdvancedOptionIncluded;